<script>
import _ from 'lodash';

export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            content: {}
        };
    },

    computed: {
        isDirty() {
            return JSON.stringify(this.content) !== JSON.stringify(this.value);
        }
    },

    watch: {
        isDirty(v) {
            this.$emit('dirty-change', v);
        },

        value: {
            handler() {
                this.content = _.cloneDeep(this.value);
            },
            deep: true
        }
    },

    created() {
        this.content = _.cloneDeep(this.value);
    }
};
</script>
